import type { TypeOpsServer } from '@/types/ops/types.ops.server';

const lastPoint = (server: TypeOpsServer): number => (server.history.length ? server.history[server.history.length - 1].t : 0);

const same = (a: TypeOpsServer, b: TypeOpsServer): boolean =>
    a.staleAfterSeconds === b.staleAfterSeconds
    && (a.snapshot?.receivedAt ?? null) === (b.snapshot?.receivedAt ?? null)
    && a.history.length === b.history.length
    && lastPoint(a) === lastPoint(b)
    && JSON.stringify(a.registry) === JSON.stringify(b.registry);

export function opsServersMerge(current: readonly TypeOpsServer[], incoming: readonly TypeOpsServer[]): TypeOpsServer[] {
    const known = new Map(current.map((server) => [server.server, server]));
    const merged = incoming.map((server) => {
        const previous = known.get(server.server);
        return previous && same(previous, server) ? previous : server;
    });
    const untouched = merged.length === current.length && merged.every((server, index) => server === current[index]);
    return untouched ? (current as TypeOpsServer[]) : merged;
}

export default opsServersMerge;
